/* Everwow top bar, final (proposal, Sep 29, 2026): the engine. The page runs this exact file and the theme ships it as
   assets/ew-season-bar.js.
   One yellow bar all year. The slides are the window's message and the four USPs. Where they all fit in one row (computers) the
   row stays still; elsewhere one slide shows at a time and the next slides up every 6 s (data-rotate, 0 keeps the message still).
   The animation plays on load and every 10 s (data-loop, 0 plays it once): Nov 1 to Dec 30 the icons light up (Tree lights up);
   every other day the icon drops in (Star drop). The option data-xm="tree_lights" adds the string of lights along the bottom
   edge: it switches on bulb by bulb, stays for data-lon lines (1), switches off for data-loff lines (2) and comes back. Pauses
   while the pointer or keyboard focus is on the bar, while the tab is hidden and while the bar is off screen. Reduce motion:
   nothing moves and nothing rotates; the message rests. Only transform and opacity move; the bar height never changes. */
(function () {
  'use strict';
  const W = window,
    XB = (W.EWXB = W.EWXB || {});
  const STAR =
    'M41.37 75.7C35.16 59.82 23.93 43.62 0 36.3 23.93 29.56 35.16 14.63 41.37 0c5.45 14.63 17.29 29.56 38.25 36.3-20.96 7.32-32.8 23.52-38.25 39.4Z';
  if (!XB.logoStar)
    XB.logoStar = function (fill, stroke) {
      return (
        '<svg viewBox="-4 -4 87.62 83.7" aria-hidden="true" focusable="false"><path d="' +
        STAR +
        '" fill="' +
        fill +
        '"' +
        (stroke
          ? ' stroke="' + stroke + '" stroke-width="6" stroke-linejoin="round"'
          : '') +
        '/></svg>'
      );
    };
  function q(el, s) {
    return el.querySelector(s);
  }
  function qa(el, s) {
    return [].slice.call(el.querySelectorAll(s));
  }
  function reduced(el) {
    return (
      (W.matchMedia &&
        W.matchMedia('(prefers-reduced-motion: reduce)').matches) ||
      !!(el && el.closest && el.closest('.xb-rm'))
    );
  }
  function A(el, frames, o) {
    if (!el || !el.animate) return null;
    o = o || {};
    return el.animate(frames, {
      duration: o.d || 400,
      delay: o.delay || 0,
      easing: o.e || 'cubic-bezier(.22,.8,.3,1)',
      fill: o.fill || 'backwards',
      iterations: 1,
    });
  }
  function seed(n) {
    return function () {
      n |= 0;
      n = (n + 0x6d2b79f5) | 0;
      let t = Math.imul(n ^ (n >>> 15), 1 | n);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  /* a damped spring sampled at 60 fps */
  function spring(from, to, k, c, ms) {
    const dt = 1 / 60,
      lim = (ms || 1400) / 1000;
    let x = from,
      v = 0,
      t = 0;
    const out = [x];
    while (t < lim) {
      const f = -k * (x - to) - c * v;
      v += f * dt;
      x += v * dt;
      out.push(x);
      t += dt;
      if (
        Math.abs(x - to) < 0.002 * (Math.abs(to - from) || 1) &&
        Math.abs(v) < 0.02
      )
        break;
    }
    out[out.length - 1] = to;
    return { v: out, d: Math.round(out.length * dt * 1000) };
  }
  function frames(vals, fn) {
    return vals.map(function (x) {
      return { transform: fn(x) };
    });
  }
  function scaleOf(bar) {
    const r = bar.getBoundingClientRect();
    return (bar.offsetWidth ? r.width / bar.offsetWidth : 1) || 1;
  }
  function pos(el, bar) {
    const r = el.getBoundingClientRect(),
      b = bar.getBoundingClientRect(),
      s = scaleOf(bar);
    return {
      x: (r.left - b.left + r.width / 2) / s,
      y: (r.top - b.top + r.height / 2) / s,
      w: r.width / s,
      h: r.height / s,
    };
  }
  function fx(bar) {
    return q(bar, '.xb-fx');
  }
  function tok(bar, name, dflt) {
    const v = getComputedStyle(bar).getPropertyValue(name).trim();
    return v || dflt;
  }
  /* particle colours: --xb-p1 to --xb-p3 (red, green and white from Nov 1 to Dec 30); --xb-pk outlines white particles on yellow */
  function cols(bar) {
    const a = tok(bar, '--xb-p1', '#FFFFFF'),
      b = tok(bar, '--xb-p2', '#11324F'),
      c = tok(bar, '--xb-p3', '#C8432C');
    return [a, b, a, c];
  }
  /* a burst of Everwow stars from (x, y) in bar pixels */
  function burst(bar, x, y, o) {
    if (reduced(bar)) return;
    o = o || {};
    const n = o.n || 5,
      host = fx(bar),
      C = o.c || cols(bar),
      a0 = o.a0 == null ? -90 : o.a0,
      spread = o.spread == null ? 110 : o.spread,
      R = seed((o.seed || 7) + Math.round(x)),
      pk = tok(bar, '--xb-pk', 'none');
    if (!host) return;
    for (let i = 0; i < n; i++) {
      const p = document.createElement('span');
      p.className = 'xb-p';
      const col = C[i % C.length];
      p.innerHTML = XB.logoStar(
        col,
        pk !== 'none' && /^#f/i.test(col) ? pk : null,
      );
      host.appendChild(p);
      const ang =
          ((a0 -
            spread / 2 +
            spread * (n === 1 ? 0.5 : i / (n - 1)) +
            (R() - 0.5) * 14) *
            Math.PI) /
          180,
        dist = (o.dist || 12) * (0.75 + R() * 0.5),
        sz = (o.size || 1) * (0.8 + R() * 0.5);
      const dx = Math.cos(ang) * dist,
        dy = Math.sin(ang) * dist;
      const fr = [
        {
          opacity: 0,
          transform:
            'translate(' + x + 'px,' + y + 'px) scale(.2) rotate(0deg)',
        },
        {
          opacity: 1,
          transform:
            'translate(' +
            (x + dx * 0.55) +
            'px,' +
            (y + dy * 0.55) +
            'px) scale(' +
            sz +
            ') rotate(40deg)',
          offset: 0.4,
        },
        {
          opacity: 0,
          transform:
            'translate(' +
            (x + dx) +
            'px,' +
            (y + dy) +
            'px) scale(' +
            sz * 0.4 +
            ') rotate(90deg)',
        },
      ];
      const an = A(p, fr, {
        d: o.d || 560,
        delay: (o.delay || 0) + i * (o.stag || 22),
        e: 'cubic-bezier(.2,.7,.3,1)',
        fill: 'both',
      });
      (function (pp, aa) {
        if (aa)
          aa.onfinish = function () {
            pp.remove();
          };
        else pp.remove();
      })(p, an);
    }
  }
  XB.burst = burst;
  /* ---------- the slides ---------- */
  function slides(bar) {
    return qa(bar, '.xb-it').filter(function (e) {
      // a USP hidden as a repeat of the day's line (snippets/ew-season-bar.liquid) is not a slide
      return (
        !e.hidden &&
        (!e.classList.contains('xb-msg') || e.classList.contains('is-on'))
      );
    });
  }
  XB.slides = slides;
  function isX(bar) {
    return bar.getAttribute('data-xmas') === '1';
  }
  function lead(bar) {
    const c = q(bar, '.xb-it.xb-cur');
    return c || slides(bar)[0];
  }
  XB.lead = lead;
  function show(bar, i) {
    const its = slides(bar),
      n = its.length;
    if (!n) return;
    i = ((i % n) + n) % n;
    const cur = q(bar, '.xb-it.xb-cur'),
      nx = its[i];
    if (cur && cur !== nx) {
      cur.classList.remove('xb-cur');
      cur.classList.add('xb-out');
      setTimeout(function () {
        cur.classList.remove('xb-out');
      }, 520);
    }
    nx.classList.remove('xb-out');
    nx.classList.add('xb-cur');
    bar._i = i;
  }
  XB.show = show;
  /* row mode: from 990 px, when the message and the four USPs fit side by side, they all show and nothing rotates */
  function layout(bar) {
    const its = slides(bar),
      w = bar.clientWidth;
    let can = w >= 990 && its.length > 1;
    if (can) {
      const g = parseFloat(tok(bar, '--xb-gap', '26')) || 26,
        pad = parseFloat(tok(bar, '--xb-pad', '14')) || 14;
      let tot = 2 * pad;
      its.forEach(function (e, i) {
        const inn = q(e, '.xb-in');
        tot += (inn ? inn.offsetWidth : e.offsetWidth) + (i ? 2 * g - 8 : 0);
      });
      can = tot <= w;
    }
    bar.classList.toggle('xb-rowm', can);
    if (!q(bar, '.xb-it.xb-cur')) show(bar, bar._i || 0);
    return can;
  }
  XB.layout = layout;
  /* ---------- the motions ---------- */
  /* Tree lights up: the icon's lights pop on one by one and its star spins in (any icon with .i-l or .i-st) */
  function lightsUp(bar, box, d0) {
    const ls = qa(box, '.i-l'),
      st = q(box, '.i-st'),
      p = pos(box, bar),
      step = 110;
    if (!ls.length && !st) return pop(bar, box, d0);
    ls.forEach(function (l, i) {
      A(
        l,
        [
          { opacity: 0, transform: 'scale(.2)' },
          { opacity: 1, transform: 'scale(1.7)', offset: 0.55 },
          { opacity: 1, transform: 'scale(1)' },
        ],
        { d: 380, delay: d0 + i * step },
      );
    });
    const t = d0 + ls.length * step;
    if (st)
      A(
        st,
        [
          { transform: 'rotate(-180deg) scale(0)' },
          { transform: 'rotate(0deg) scale(1.5)', offset: 0.65 },
          { transform: 'rotate(0deg) scale(1)' },
        ],
        { d: 520, delay: t },
      );
    burst(bar, p.x, p.y - p.h * 0.5, {
      n: 4,
      dist: 10,
      delay: t + 200,
      spread: 160,
    });
  }
  function pop(bar, box, d0) {
    const sv = q(box, 'svg'),
      p = pos(box, bar),
      sp = spring(0.5, 1, 280, 12, 800);
    A(
      sv,
      frames(sp.v, function (v) {
        return 'scale(' + Math.max(0, v) + ') rotate(' + -40 * (1 - v) + 'deg)';
      }),
      { d: sp.d, e: 'linear', delay: d0 },
    );
    burst(bar, p.x, p.y - p.h * 0.2, {
      n: 3,
      dist: 9,
      delay: d0 + 120,
      spread: 150,
    });
  }
  /* Star drop: the icon falls from the top edge into its slot, squashes on landing and six small stars burst out */
  function drop(bar, box, d0) {
    const sv = q(box, 'svg'),
      p = pos(box, bar),
      from = -(p.y + p.h);
    if (!sv) return;
    const sp = spring(from, 0, 300, 13, 900),
      fr = sp.v.map(function (v, j) {
        const land =
          j > 3 && Math.abs(v) < 1.5 ? 1 - 0.22 * Math.exp(-(j - 3) / 2.5) : 1;
        return {
          transform:
            'translateY(' +
            v +
            'px) scaleY(' +
            land +
            ') scaleX(' +
            (2 - land) +
            ')',
        };
      });
    fr[fr.length - 1] = { transform: 'none' };
    A(sv, fr, { d: sp.d, e: 'linear', delay: d0 });
    burst(bar, p.x, p.y - p.h * 0.1, {
      n: 6,
      dist: 13,
      delay: d0 + Math.min(260, sp.d * 0.3),
      spread: 200,
      a0: -90,
    });
  }
  /* Lights on: a string of red, green and white lights along the bottom edge (Nov 1 to Dec 30) */
  function lightsSetup(bar) {
    const host = fx(bar),
      Wd = bar.offsetWidth || 390,
      H = bar.offsetHeight || 30;
    if (!host) return;
    if (bar._lw === Wd && q(host, '.xb-bulb')) return;
    bar._lw = Wd;
    const gap = 22,
      n = Math.max(6, Math.floor((Wd - 8) / gap)),
      off = (Wd - (n - 1) * gap) / 2,
      y = H - 7.4;
    let d = '',
      i;
    const pal = tok(bar, '--xb-bulbs', '#C8432C,#0E7A4F,#FFFFFF')
      .split(',')
      .map(function (c) {
        return c.trim();
      });
    for (i = 0; i < n; i++) {
      const x = off + i * gap;
      d += i
        ? ' Q' + (x - gap / 2) + ' ' + (y + 1.9) + ' ' + x + ' ' + y
        : 'M' +
          (x - gap / 2) +
          ' ' +
          (y + 0.9) +
          ' Q' +
          (x - gap / 4) +
          ' ' +
          (y + 0.5) +
          ' ' +
          x +
          ' ' +
          y;
    }
    d +=
      ' Q' +
      (off + (n - 1) * gap + gap / 4) +
      ' ' +
      (y + 0.5) +
      ' ' +
      (off + (n - 1) * gap + gap / 2) +
      ' ' +
      (y + 0.9);
    let h =
      '<svg class="xb-wire" viewBox="0 ' +
      (H - 9) +
      ' ' +
      Wd +
      ' 9" preserveAspectRatio="none" style="height:9px"><path d="' +
      d +
      '" stroke="currentColor" stroke-width="1" fill="none" opacity=".7"/></svg>';
    for (i = 0; i < n; i++)
      h +=
        '<span class="xb-bulb" style="left:' +
        (off + i * gap).toFixed(1) +
        'px;--c:' +
        pal[i % pal.length] +
        '"><i></i></span>';
    qa(host, '.xb-wire,.xb-bulb').forEach(function (e) {
      e.remove();
    });
    host.insertAdjacentHTML('afterbegin', h);
    bar.classList.add(
      'xb-lit',
    ); /* xb-lit keeps the words 3 px up while the option is on, lit or not */
  }
  /* the lights come on bulb by bulb (the same motion as before) and go away bulb by bulb */
  function lightsOn(bar) {
    bar.classList.add('xb-lon');
    const b = qa(bar, '.xb-bulb'),
      w = q(bar, '.xb-wire');
    if (!b.length) return;
    const stp = Math.min(42, 1100 / b.length);
    if (w) A(w, [{ opacity: 0 }, { opacity: 1 }], { d: 300 });
    b.forEach(function (el, i) {
      A(
        el,
        [
          { opacity: 0, transform: 'scale(.6)' },
          { opacity: 1, transform: 'scale(1.22)', offset: 0.45 },
          { opacity: 1, transform: 'scale(1)' },
        ],
        { d: 380, delay: 120 + i * stp },
      );
      A(
        q(el, 'i'),
        [{ opacity: 0 }, { opacity: 0.95, offset: 0.4 }, { opacity: 0.5 }],
        { d: 560, delay: 120 + i * stp },
      );
    });
  }
  function lightsOff(bar) {
    const b = qa(bar, '.xb-bulb'),
      w = q(bar, '.xb-wire');
    if (!b.length) {
      bar.classList.remove('xb-lon');
      return;
    }
    const stp = Math.min(30, 800 / b.length),
      end = 380 + b.length * stp;
    b.forEach(function (el, i) {
      A(
        el,
        [
          { opacity: 1, transform: 'scale(1)' },
          { opacity: 0, transform: 'scale(.6)' },
        ],
        { d: 380, delay: i * stp, fill: 'forwards' },
      );
      A(q(el, 'i'), [{ opacity: 0.5 }, { opacity: 0 }], {
        d: 300,
        delay: i * stp,
        fill: 'forwards',
      });
    });
    if (w)
      A(w, [{ opacity: 1 }, { opacity: 0 }], {
        d: 300,
        delay: Math.max(0, end - 250),
        fill: 'forwards',
      });
    setTimeout(function () {
      bar.classList.remove('xb-lon');
      qa(bar, '.xb-bulb,.xb-bulb i,.xb-wire').forEach(function (e) {
        if (e.getAnimations)
          e.getAnimations().forEach(function (a) {
            a.cancel();
          });
      });
    }, end + 150);
  }
  XB.lightsOn = lightsOn;
  XB.lightsOff = lightsOff;
  /* the Christmas motion: 'tree' (Tree lights up, the default) or 'tree_lights' (plus the string of lights now and then) */
  function motion(bar) {
    const m = bar.getAttribute('data-xm') || 'tree';
    return m === 'tree_lights' || m === 'both' || m === 'lights'
      ? 'tree_lights'
      : 'tree';
  }
  function hasLights(bar) {
    return isX(bar) && motion(bar) === 'tree_lights';
  }
  /* one beat of the loop: every icon on show lights up (Christmas) or drops in (other days); one in rotation, all in the row, 150 ms apart */
  function play(bar) {
    if (reduced(bar)) return;
    const row = bar.classList.contains('xb-rowm'),
      its = row ? slides(bar) : [lead(bar)],
      boxes = its
        .map(function (it) {
          return it && q(it, '.xb-ic');
        })
        .filter(Boolean);
    boxes.forEach(function (b, i) {
      if (isX(bar)) lightsUp(bar, b, i * 150);
      else drop(bar, b, i * 150);
    });
  }
  XB.play = play;
  /* ---------- mount: the rotation, the loop and the lights rhythm, with every pause ----------
     One clock of steps, a step every data-rotate seconds (6; when the rotation is off the lights still step every 6 s). On each step
     the next line shows (where they do not fit in one row) and the lights follow their rhythm: on for data-lon steps, off for
     data-loff steps (1 and 2; 0 off keeps them on). The animation plays on load and every data-loop seconds (10; 0 plays it once). */
  XB.mount = function (bar, o) {
    o = o || {};
    if (!bar || bar._xb) return bar && bar._xb;
    const wrap = bar.closest('[data-xb-season]'),
      rd = function (k, d) {
        let v = o[k] != null ? o[k] : wrap && wrap.getAttribute('data-' + k);
        v = v == null || v === '' ? d : +v;
        return isNaN(v) ? d : v;
      };
    const st = (bar._xb = {
      loop: Math.max(0, rd('loop', 10)) * 1000,
      rot: Math.max(0, rd('rotate', 6)) * 1000,
      lon: Math.max(1, Math.round(rd('lon', 1))),
      loff: Math.max(0, Math.round(rd('loff', 2))),
      hover: false,
      focus: false,
      seen: true,
      pz: 0,
      last: 0,
      lastStep: 0,
      step: 0,
      lit: false,
    });
    st.stepMs = st.rot || 6000;
    show(bar, o.start || 0);
    bar.classList.add('xb-js');
    if (hasLights(bar)) lightsSetup(bar);
    layout(bar);
    const re = function () {
      if (hasLights(bar)) lightsSetup(bar);
      layout(bar);
    };
    if (W.ResizeObserver) {
      st.ro = new ResizeObserver(function () {
        re();
      });
      st.ro.observe(bar);
    } else W.addEventListener('resize', re);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(re);
    if (reduced(bar) || o.still) {
      if (hasLights(bar)) {
        bar.classList.add('xb-lon');
        st.lit = true;
      }
      return st;
    }
    bar.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'mouse') st.hover = true;
    });
    bar.addEventListener('pointerleave', function () {
      st.hover = false;
    });
    bar.addEventListener('focusin', function () {
      st.focus = true;
    });
    bar.addEventListener('focusout', function () {
      st.focus = false;
    });
    if (W.IntersectionObserver) {
      st.io = new IntersectionObserver(function (es) {
        es.forEach(function (x) {
          st.seen = x.isIntersecting;
        });
      });
      st.io.observe(bar);
    }
    const lightsAt = function () {
      if (!hasLights(bar)) return;
      const on = st.loff === 0 || st.step % (st.lon + st.loff) < st.lon;
      if (on && !st.lit) {
        st.lit = true;
        lightsOn(bar);
      } else if (!on && st.lit) {
        st.lit = false;
        lightsOff(bar);
      }
    };
    const t0 = Date.now();
    st.last = t0;
    st.lastStep = t0;
    setTimeout(
      function () {
        if (reduced(bar)) return;
        lightsAt();
        play(bar);
      },
      o.delay == null ? 250 : o.delay,
    );
    st.timer = setInterval(function () {
      if (!bar.isConnected) {
        clearInterval(st.timer);
        if (st.ro) st.ro.disconnect();
        if (st.io) st.io.disconnect();
        return;
      }
      const now = Date.now();
      if (st.hover || st.focus || document.hidden || !st.seen || reduced(bar)) {
        if (!st.pz) st.pz = now;
        return;
      }
      if (st.pz) {
        st.last += now - st.pz;
        st.lastStep += now - st.pz;
        st.pz = 0;
      }
      if (now - st.lastStep >= st.stepMs) {
        st.lastStep = now;
        st.step++;
        const rotating =
          !bar.classList.contains('xb-rowm') &&
          st.rot > 0 &&
          slides(bar).length > 1;
        if (rotating) show(bar, (bar._i || 0) + 1);
        lightsAt();
        if (st.loop && now - st.last >= st.loop - 300) {
          st.last = now;
          setTimeout(
            function () {
              play(bar);
            },
            rotating ? 460 : 0,
          );
        }
        return;
      }
      if (st.loop && now - st.last >= st.loop) {
        st.last = now;
        play(bar);
      }
    }, 200);
    return st;
  };
  /* the page's Play again: back to the message and one beat now; with the lights option the lights come on again */
  XB.replay = function (bar) {
    if (!bar || reduced(bar)) return;
    if (bar.getAnimations)
      bar.getAnimations({ subtree: true }).forEach(function (a) {
        a.cancel();
      });
    qa(bar, '.xb-p').forEach(function (p) {
      p.remove();
    });
    show(bar, 0);
    const st = bar._xb;
    if (st) {
      st.last = st.lastStep = Date.now();
      st.step = 0;
    }
    if (hasLights(bar)) {
      if (st) st.lit = true;
      lightsOn(bar);
    }
    setTimeout(function () {
      play(bar);
    }, 60);
  };
})();
/* boot: start the bar (the wrapper's data-loop and data-rotate carry the theme settings) */
(function () {
  function boot() {
    [].forEach.call(
      document.querySelectorAll('[data-xb-season] .xb'),
      function (b) {
        window.EWXB.mount(b);
      },
    );
  }
  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
